import ACTIONS from "../actions/types";

const initialState = {
  organisationList: [],
  deviceNameList: [],
  deviceModelList: [],
  packages: [],
  errorCodes: [],
  statusCodes: [],
};

const monitoringsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.MONITORING_MODULE.GET_ORGANISATION_LIST:
      return {
        ...state,
        organisationList: [...payload], // Assumes payload is an array
      };
    case ACTIONS.MONITORING_MODULE.GET_DEVICENAME_LIST:
      return {
        ...state,
        deviceNameList: [...payload],
      };
    case ACTIONS.MONITORING_MODULE.GET_DEVICEMODEL_LIST:
      return {
        ...state,
        deviceModelList: [...payload],
      };
    case ACTIONS.MONITORING_MODULE.GET_PACKAGES:
      return {
        ...state,
        packages: [...payload],
      };
    case ACTIONS.MONITORING_MODULE.GET_ERROR_CODES:
      return {
        ...state,
        errorCodes: [...payload],
      };
    case ACTIONS.MONITORING_MODULE.GET_STATUS_CODES:
      return {
        ...state,
        statusCodes: [...payload],
      };
    default:
      return state;
  }
};

export default monitoringsReducer;
